export const INTERACTION_ORIGIN = {
    alternatives: 'alternatives',
    brandwall: 'brandwall',
    cart: 'cart',
    combinations: 'combinations',
    emptyCart: 'empty_cart',
    favorites: 'favorites',
    frontPage: 'front_page',
    listing: 'listing',
    product: 'product',
    recent: 'recent',
    relatedItems: 'related_items',
    searchResultPage: 'search_result_page',
    sharedCart: 'shared_cart',
    sharedWishlist: 'shared_wishlist',
    stylitics: 'stylitics',
    thankyou: 'thankyou',
    upsell: 'upsell',
    wishlist: 'wishlist',
} as const;

export const ITEM_LIST_TYPE = {
    alternatives: 'alternatives',
    brandwall: 'brandwall',
    carousel: 'carousel',
    combineWith: 'combine_with',
    emptyCart: 'empty_cart',
    listing: 'listing',
    myOrders: 'my_orders',
    myProducts: 'my_products',
    myReturns: 'my_returns',
    productFinder: 'product_finder',
    related: 'related',
    searchPageResult: 'search_page_result',
    searchSuggestions: 'search_suggestions',
    sharedCart: 'shared_cart',
    sharedWishlist: 'shared_collection',
    shopTheLook: 'shop_the_look',
    shopcart: 'shopcart',
    stylitics: 'stylitics',
    thankYou: 'thankyou',
    upsell: 'upsell',
} as const;

export const ITEM_LIST_NAME = {
    alternatives: 'alternatives',
    brandwall: 'brandwall',
    carouselCategory: 'carousel_category',
    carouselImageCategory: 'carousel_image_category',
    carouselSingle: 'carousel_single',
    combineWith: 'combine_with',
    myOrders: 'my_orders',
    favorites: 'favorites',
    recent: 'recent',
    wishlist: 'wishlist',
    myReturns: 'my_returns',
    related: 'related',
    searchPageResult: 'search_page_result',
    searchSuggestions: 'search_suggestions',
    shopcart: 'shopcart',
    sharedCart: 'shared_cart',
    sharedWishlist: 'shared_collection',
    shopTheLook: 'shop_the_look',
    thankYou: 'thankyou',
    stylitics: 'stylitics',
    upsell: 'upsell',
} as const;

export const LOGIN_STATUS = {
    visitor: 'visitor',
    user: 'user',
    club: 'club',
    premium: 'premium',
} as const;
